import React from 'react';
import { render } from 'react-dom';

// Bootstrap shims (i18n, dev icon sprite) - imported first
import '../../bootstrap.js';
import models from '../../utilities/models.js';
import Policies from '../../views/policies/index.js';
import { tweakPoliciesCountries, tweakPoliciesCountryGroups } from '../../utilities/tweakModels.js';

import '../../utilities/googleTranslateHack.js';

import '../../styles.js';

function load() {
  const preview = location.search.includes('preview=1');

  const modelsRequest = fetch(`${__config.api_path}models`).then((response) => {
    return response.json();
  });

  const policiesModelsRequestParams = [];
  if (preview) {
    policiesModelsRequestParams.push('preview=1');
  }
  if (__config.policiesApiExcludeIds) {
    policiesModelsRequestParams.push(`exclude=${__config.policiesApiExcludeIds.join(',')}`);
  }
  if (__config.policiesApiIncludeIds) {
    policiesModelsRequestParams.push(`include=${__config.policiesApiIncludeIds.join(',')}`);
  }

  // TODO: Allow policy models to be inlined into host page
  const policiesModelsRequest = fetch(
    `${__config.policiesApiUrl}models?${policiesModelsRequestParams.join('&')}`
  ).then((response) => {
    return response.json();
  });

  Promise.all([modelsRequest, policiesModelsRequest]).then(([modelsData, policyModelsData]) => {
    init(modelsData, policyModelsData);
  });
}

function init(rawModelsData, rawPolicyModelsData) {
  tweakPoliciesCountries(rawModelsData);
  tweakPoliciesCountryGroups(rawModelsData);
  models.init(rawModelsData);
  render(
    <Policies models={rawPolicyModelsData} countryModels={models.countries} />,
    document.getElementById('root')
  );
}

if (document.readyState !== 'loading') {
  load();
} else {
  document.addEventListener('DOMContentLoaded', load);
}
